import _ from 'lodash';
import { SkillRealtimeRemoteDto } from 'src/generated/signalR/skill-realtime-remote-dto';
import { SkillUserConfigurationRemoteDto } from 'src/generated/signalR/skill-user-configuration-remote-dto';
import { SkillConfigurationRemoteDto } from 'src/generated/signalR/skill-configuration-remote-dto';

export class Skill {
   skillId: number;
   skillConfiguration: SkillConfigurationRemoteDto;
   skillUserConfiguration: SkillUserConfigurationRemoteDto;
   oldestCallTimeStamp: Date;
   waitCount: number;
   loggedOnUserIds: number[];
   loggedOnToAllUserIds: number[];
   redirectionAddress: string;
   requiredAgentCount: number;
   activeAgentIds: number[];

   // Add Constructor
   constructor(skillConfiguration: SkillConfigurationRemoteDto, skillUserConfig: SkillUserConfigurationRemoteDto, skillRealtimeData: SkillRealtimeRemoteDto) {
      this.skillConfiguration = skillConfiguration;
      this.skillUserConfiguration = skillUserConfig;
      this.skillId = skillConfiguration?.id ?? 0;
      this.oldestCallTimeStamp = skillRealtimeData?.oldestCallTimeStamp;
      this.waitCount = skillRealtimeData?.waitCount ?? 0;
      this.loggedOnUserIds = skillRealtimeData?.loggedOnUserIds ?? [];
      this.loggedOnToAllUserIds = skillRealtimeData?.loggedOnToAllUserIds ?? [];
      this.redirectionAddress = skillRealtimeData?.redirectionAddress ?? '';
      this.requiredAgentCount = skillRealtimeData?.requiredAgentCount ?? 0;
      this.activeAgentIds = skillRealtimeData?.activeAgentIds ?? [];
   }
}
